import { defineComponent as _defineComponent } from 'vue'
import { Icon, Typo } from '@travelata-libs/ui-kit';
    import { computed } from 'vue';
    import { BONUS_MILES_TEXT } from '../../lib/filterByBonusMiles';
    import BonusMilesIcon from './BonusMilesIcon.vue';
    import BonusMilesInfo from './BonusMilesInfo.vue';

    enum IconVariant {
        Green = 'green',
        Grey = 'grey',
        LightGreen = 'light-green',
    }

    enum TooltipIconType {
        Question = 'question',
        Airplane = 'airplane',
    }

    enum IconSpacing {
        Small = 'small', // 4px
        Medium = 'medium', // 8px
    }

    interface BonusMilesContentProps {
        iconVariant?: `${IconVariant}`;
        tooltipIcon?: `${TooltipIconType}`;
        iconSpacing?: `${IconSpacing}`;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'BonusMilesBadge',
  props: {
    iconVariant: { default: 'green' },
    tooltipIcon: { default: 'question' },
    iconSpacing: { default: 'small' }
  },
  setup(__props: any) {

const props = __props as { iconVariant: `${IconVariant}`, tooltipIcon: `${TooltipIconType}`, iconSpacing: `${IconSpacing}` }

    

    const hasDefaultTooltip = computed(() => props.tooltipIcon === TooltipIconType.Question);
    const tooltipComponent = computed(() => (hasDefaultTooltip.value ? Icon : BonusMilesIcon));
    const tooltipType = computed(() => (hasDefaultTooltip.value ? 'black' : 'white'));

return { __sfc: true,IconVariant, TooltipIconType, IconSpacing, props, hasDefaultTooltip, tooltipComponent, tooltipType, Typo, BONUS_MILES_TEXT, BonusMilesIcon, BonusMilesInfo }
}

})